import {
  Linkedin,
  Twitter,
  Facebook,
  Briefcase
} from "lucide-react";

export type NavLink = {
  name: string;
  href: string;
  subLinks?: NavLink[];
};

export const navLinks: NavLink[] = [
  { name: "Home", href: "/" },
  {
    name: "Services",
    href: "/services",
  },
  {
    name: "Industries",
    href: "/industries",
  },
  {
    name: "Use Cases",
    href: "/use-cases",
  },
  { name: "About Us", href: "/about" },
  { name: "Blog", href: "/blog" },
  { name: "Contact", href: "/contact" },
];

export type Testimonial = {
  quote: string;
  name: string;
  company: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      "The AI voice agent has been a game-changer for our dental practice. No-shows are down 20%, and our front desk staff can now focus on in-person patient care. It paid for itself in the first month.",
    name: "Dr. Emily Carter",
    company: "Owner, Sunshine Dental",
  },
  {
    quote:
      "We were drowning in repetitive emails and phone calls. Tellis Technology automated our entire customer inquiry process. We're saving at least 15 hours a week.",
    name: "Michael Chen",
    company: "Founder, Pristine Cleaners",
  },
  {
    quote:
      "As a small salon, we can't afford a 24/7 receptionist. The chatbot books appointments for us day and night. It's the best employee I've ever had!",
    name: "Jessica Rodriguez",
    company: "Owner, The Glam Room",
  },
];

export type FooterLinkSection = {
  title: string;
  links: { name: string; href: string }[];
};

export const footerLinks: FooterLinkSection[] = [
  {
    title: "Company",
    links: [
      { name: "About Us", href: "/about" },
      { name: "Blog", href: "/blog" },
      { name: "Careers", href: "/careers" },
      { name: "Contact", href: "/contact" },
    ],
  },
  {
    title: "Services",
    links: [
      { name: "AI Chatbots", href: "/services/ai-chatbots" },
      { name: "AI Voice Agents", href: "/services/ai-voice-agents" },
      { name: "RAG Systems", href: "/services/rag-systems" },
      { name: "Workflow Automation", href: "/services/workflow-automation" },
    ],
  },
  {
    title: "Legal",
    links: [
      { name: "Privacy Policy", href: "/privacy-policy" },
      { name: "Terms of Service", href: "/terms-of-service" },
      { name: "FAQ", href: "/faq" },
      
    ],
  },
];

export type SocialLink = {
  name: string;
  href: string;
  icon: any;
};

export const socialLinks: SocialLink[] = [
  { name: "LinkedIn", href: "https://www.linkedin.com/company/tellis/", icon: Linkedin },
  { name: "Facebook", href: "https://www.facebook.com/TellisTechnologies/", icon: Facebook },
  {name:"Internshala", href:"https://internshala.com/company/tellis-technologies-private-limited-1723172983/careers/", icon: Briefcase},
];

export const valuesData = [
  {
    title: "Automate Support",
    description:
      "Our AI agents provide 24/7 customer service, answering questions and resolving issues instantly.",
    image: "/AIChatbots.jpg",
  },
  {
    title: "Streamline Operations",
    description:
      "From appointment scheduling to invoicing, automate your workflows and eliminate manual data entry.",
    image: "/AutomatioWorkflow.jpg",
  },
  {
    title: "Enhance Engagement",
    description:
      "Generate leads, nurture them with personalized communication, and increase customer loyalty.",
    image: "/CustomConsultation.jpg",
  },
  {
    title: "Voice Sales Agent",
    description:
      "AI voice agents that qualify leads, book demos, and close deals around the clock.",
    image: "/voiceAgent.jpg",
  },
  {
    title: "Smart Analytics",
    description:
      "Turn every interaction into actionable insights with real-time dashboards and predictive reports.",
    image: "/RAGSystems.jpg",
  },
]; 